import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import ChangeRequestListComponent from './list/list.component.js'

import { getChangeRequests, statusType } from '../../../actions'
import { format, getPageSize } from '../../../utils'

import './landing.page.scss'
import { Banner } from '../../../components'

/**
 * Change requests landing Page
 */
class ChangeRequestLandingPage extends Component {
  /**
   * Constructor
   * @param props
   */
  constructor(props) {
    super(props)
    this.state = {
      isSidebarCollapsed: true,
      filters: {
        limit: getPageSize('change-request-list') || 10,
        page: 1
      }
    }
  }

  /**
   * Component did mount
   */
  componentDidMount () {
    this.getChangeRequests()
  }

  /**
   * Get change requests
   */
  getChangeRequests = () => {
    const { getChangeRequests } = this.props
    const { filters } = this.state
    getChangeRequests(filters)
  }


  /**
   * Fetch requests based on provided filters (page and limit)
   * @param filters
   */
  handleFilterChange = (filters) => {
    this.setState(
      { filters: { ...this.state.filters, ...filters } },
      () => this.getChangeRequests()
    )
  }

  /**
   * Render Change Request List
   * @returns {*}
   */
  render () {
    const { changeRequest: { data, total, maxTotal, status, initialLoading }, history } = this.props
    const { filters } = this.state

    return (
      <>
        <Banner
          title={`Change Requests (${format(total || 0)})`}
          icon='q4i-stage-2pt'
        />

        <div className='change-request-landing-page_grid'>
          <div className='change-request-landing-page_grid-body page_grid'>
            <ChangeRequestListComponent
              isGridReady={!initialLoading}
              loading={status === statusType.IN_PROGRESS}
              data={data}
              filters={filters}
              history={history}
              total={(total > maxTotal) ? maxTotal : total}
              handleFilterChange={this.handleFilterChange} />
          </div>
        </div>
      </>
    )
  }
}

ChangeRequestLandingPage.propTypes = {
  history: PropTypes.object,
    changeRequest: PropTypes.shape({
      data: PropTypes.array,
      total: PropTypes.number,
      maxTotal: PropTypes.number,
      status: PropTypes.string,
      initialLoading: PropTypes.bool
    }),
    getChangeRequests: PropTypes.func
}

const mapStateToProps = (state) => {
  return {
    changeRequest: state.changeRequest.changeRequest
  }
}

const mapDispatchToProps = (dispatch) => ({
  getChangeRequests: bindActionCreators(getChangeRequests, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(ChangeRequestLandingPage)
